import { render } from "./BouquetSVG.vue?vue&type=template&id=10e4d14a"
import script from "./BouquetSVG.vue?vue&type=script&lang=js"
export * from "./BouquetSVG.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__